export const SET_ICE_SERVERS = "SET_ICE_SERVERS";

export const setIceServers = (data) => ({
  type: SET_ICE_SERVERS,
  payload: data,
});
